/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import ActionButton from "./ActionButton";
import Bulb from '../../../assets/logos/Bulb.svg';
import BenefitSearch from '../../../assets/logos/benefit-search-icn.svg';
import SaveBtnBox from '../../../assets/logos/save-btn-chatbox.svg';
import FeedbackToggle from "./FeedbackToggle";

const SuggestedActions = ({
  applicationCount,
  onRunDuplicateCheck,
  onSaveForLater,
  runDuplicateLabel,
  saveLaterLabel,
  showViewReportButton = false,
  disabled = false,
}) => (
  <>
    {showViewReportButton && (
      <div className="suggested-actions">
        <h4>SUGGESTED ACTIONS</h4>
        <div className="action-wrapper">

          <ActionButton
            label={runDuplicateLabel || `Run duplicate check on all ${applicationCount} applications`}
            onClick={onRunDuplicateCheck}
            btnImage={BenefitSearch}
            disabled={disabled}
          />
          {saveLaterLabel && (
            <ActionButton
              label={saveLaterLabel || "Save it for later"}
              onClick={onSaveForLater}
              btnImage={SaveBtnBox}
            />
          )}
          <FeedbackToggle
            onChange={(value) => {
              console.log("User feedback:", value);
            }}
          />

          {/* <a href="#" className="generate-link"> */}
          {/* <img src={Bulb} className="Bulb-icon" alt="" /> */}
          {/* <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.1665 6.99984H1.81465M6.99984 1.1665V1.81465M12.185 6.99984H12.8332M2.85169 2.85169L3.30539 3.30539M11.148 2.85169L10.6943 3.30539M5.50906 10.2406H8.49055M5.05539 9.59243C4.51125 9.18432 4.10931 8.61536 3.90651 7.96612C3.7037 7.31688 3.71031 6.6203 3.9254 5.97502C4.14049 5.32975 4.55316 4.76852 5.10494 4.37081C5.65673 3.97311 6.31966 3.7591 6.99984 3.7591C7.68001 3.7591 8.34295 3.97311 8.89473 4.37081C9.44652 4.76852 9.85918 5.32975 10.0743 5.97502C10.2894 6.6203 10.296 7.31688 10.0932 7.96612C9.89036 8.61536 9.48842 9.18432 8.94428 9.59243C8.69122 9.84293 8.50069 10.1495 8.38809 10.4873C8.27549 10.8251 8.24399 11.1846 8.29613 11.5369C8.29613 11.8807 8.15956 12.2104 7.91646 12.4535C7.67335 12.6966 7.34364 12.8332 6.99984 12.8332C6.65604 12.8332 6.32632 12.6966 6.08322 12.4535C5.84011 12.2104 5.70354 11.8807 5.70354 11.5369C5.75569 11.1846 5.72419 10.8251 5.61159 10.4873C5.49899 10.1495 5.30845 9.84293 5.05539 9.59243Z" stroke="#0857C3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>

          Generate Other Suggestions
        </a> */}
        </div>
      </div>
    )}
  </>
);

export default SuggestedActions;
